import { memo } from 'react';

import CardPlayer from 'app/components/modules/card-player/CardPlayer';
import EnvelopePreview from 'app/components/modules/envelope-preview/EnvelopePreview';
import PromoPreview from 'app/components/modules/promo-preview/PromoPreview';
import GiftPreview from 'app/components/modules/gift-preview/GiftPreview';
import EmbedGiftChange from 'app/components/screens/EmbedGiftChange';
import { useAppContext } from 'lib/AppContext';

const App = () => {
  const { location } = useAppContext();
  if (['/preview-page/envelope', '/envelope'].includes(location.pathname)) {
    return (<EnvelopePreview />);
  }
  if (['/preview-page/promo', '/promo'].includes(location.pathname)) {
    return (<PromoPreview />);
  }
  if (['/preview-page/gift'].includes(location.pathname)) {
    return (<GiftPreview />);
  }
  if (['/embed/gift-change'].includes(location.pathname)) {
    return (<EmbedGiftChange />);
  }
  return (<CardPlayer />);
};

export default memo(App);
